import PropTypes from 'prop-types';

export const FormControlPropTypes = {
    id: PropTypes.string.isRequired,
    touched: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onTouched: PropTypes.func.isRequired,
    messages: PropTypes.any.isRequired,
    triedSubmit: PropTypes.any.isRequired,
};

export type FormControlProps = {
    id: string;
    touched: boolean;
    valid: boolean;
    onChange: (value) => void;
    onTouched: () => void;
    messages: {
        errors?: unknown;
    };
    triedSubmit: unknown;
    validator?: unknown;
    value?: unknown;
    required: boolean;
    pristine?: boolean;
    isValidating?: boolean;
};
